import {Baseline} from '../interfaces';

/**
 * Baselines are stored one row per player session, so a profile has many rows
 * of the same session type. Reduce them to the most recent baseline per type.
 *
 * Sorting ascending and letting the last write win keeps rows with no
 * lastSessionDate from ever beating a dated one.
 */
const getLatestBaselineByType = (baselines?: Baseline[]) => {
  const latest: Record<string, Baseline> = {};
  [...(baselines ?? [])]
    .sort(
      (a, b) =>
        new Date(a.lastSessionDate ?? 0).getTime() -
        new Date(b.lastSessionDate ?? 0).getTime(),
    )
    .forEach(baseline => {
      if (baseline.type) {
        latest[baseline.type] = baseline;
      }
    });
  return latest;
};

export {getLatestBaselineByType};
